declare global {
    interface Window {
        cordova: unknown;
    }
}

export const useCapacitor = () => {
    const isCordova = !!window.cordova;

    return { isCordova };
};
